export default __webpack_public_path__ + "static/media/frog.59197627.svg";